import Component from './SearchHero';
import { Props, MapProps } from '../../BlockMapper';
import TestData from './test.data';

const _map = (block: any, test = false) => {
  let data = test ? TestData : MapProps(block);
  const props: Props = data;
  return (
    <Component
      {...props}
      header={props.header!}
      locale={props.locale!}
      shopNavigationOptions={props.shopNavigationOptions ?? {}}
    />
  );
};

export default _map;
